import { Component, OnDestroy } from '@angular/core';

import { Subject } from 'rxjs';

@Component({
    selector: 'rcore-base',
    template: ''
})
export class BaseComponent implements OnDestroy {
    protected componentDestroyed$ = new Subject<void>();

    ngOnDestroy() {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
}
